<style scoped lang="less">
.echart-main {
  width: 100%;
  height: 400px;
}
</style>
<template>
  <div>
    <div class="page-content">
      <div class="title">
        <el-row>
          <el-col :span="4">查询结果</el-col>
          <el-col :span="20" class="text-right">
            <el-button
              size="small"
              type="primary"
              plain
              v-for="(item, index) in downBtn"
              :key="index"
              @click="downCsv(item.value)"
            >{{ item.name }}</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="content">
        <div :id="echartId" class="echart-main"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "statisticsEchartsOptionBar",
  props: {
    title: String,
    optionData: Object,
    echartId: {
      type: String,
      required: true,
    },
    downCsvBtn: Function,
  },
  data() {
    return {
      titleTime: "1小时",
      newEchart: "",
      downBtn: [
        {
          name: "下载数据",
          value: "1d",
        },
      ],
      option: {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // console.log("pa", params);
            let html = `
                <div class="tooltip-box">
                ${params[0].axisValueLabel} <br>
                ${params[0].marker}${params[0].data.name}: ${params[0].data.value}
                </div>
            `;
            return html;
          },
        },
        legend: {
          //   data: ["大气压"]
        },
        grid: {},
        xAxis: [
          {
            type: "category",
            // boundaryGap: false,
            data: [],
            axisLable: {
              interval: 3,
            },
          },
        ],
        yAxis: {
          name: "",
          splitLine: {
            show: false, // X轴 网格线 颜色类型的修改
          },
        },
        series: [
          {
            name: "",
            type: "bar",
            // smooth: true,
            // showAllSymbol: true,
            // symbol: "circle",
            // symbolSize: 5,
            data: [],
            // lineStyle: {
            //   color: "#6495ed",
            //   width: 2,
            // },
            itemStyle: {
              color: "#0066cc",
            },

            areaStyle: {
              normal: {
                color: "#0066cc",
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    downCsv(time) {
      this.$emit("downCsvBtn", time);
    },
    newEcharts() {
      console.log("echartId", this.optionData.dataY);
      this.option.yAxis.name = this.optionData.title + this.optionData.unit; //单位
      this.option.xAxis[0].data = this.optionData.dataX;
      this.option.series[0].data = this.optionData.dataY; //y轴数据
      this.option.series[0].name = this.optionData.title; //展示数据title
      this.option.xAxis[0].axisLable.interval = parseInt(
        this.optionData.dataX.length / 30
      );

      this.newEchart = this.$Echarts.init(
        document.getElementById(this.echartId)
      );
      // this.newEchart.addEventListener('click', function(){
      //       alert("这是第二中点击方式");
      //   })
      this.newEchart.setOption(this.option);

      // this.newEchart.on('click', (params) => {
      //   console.log('params',params)
      // });
    },
  },
  mounted() {
    setTimeout(() => {
      this.newEcharts();
    }, 1000);
  },
  watch: {
    optionData: {
      handler(newName, oldName) {
        this.newEcharts();
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/statisticsEchartsOptionBar.vue